import React from 'react';

import { SupervisorAccountOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { ActionItemKeys } from '@uplift/api';
import { trackToDoCTA } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { LinkDashboardActionItem } from '@uplift/ui-v2';
import { ROUTING_CONFIG } from '@uplift/constants';


export type ChartsReviewOverdueToDoProps = {
  chartsReviewsCount: number;
};


export const ChartsReviewOverdueToDo: React.VFC<ChartsReviewOverdueToDoProps> = ({ chartsReviewsCount }) => {
  return (
    <LinkDashboardActionItem
      title={<Typography>You have <strong>{chartsReviewsCount} overdue charts review{chartsReviewsCount > 1 ? 's' : ''}</strong> need to complete across your supervised providers</Typography>}
      color="danger"
      icon={<SupervisorAccountOutlined />}
      link={ROUTING_CONFIG.chartsReviews}
      actionText="Manage"
      onClick={() => {
        trackToDoCTA({
          toDoType: ActionItemKeys.PROVIDER_CHARTS_REVIEWS_OVERDUE,
          userType: UserRole.provider
        });
      }}
    />
  );
};
